<template>
    <WorkScheduleContainerRow>
        <WorkScheduleContainerColumn headerColumn stickyLeft><span class="groupName">Groep</span></WorkScheduleContainerColumn>
        <WorkScheduleContainerColumn headerColumn><span class="stickyHeaderContent">Werkindeling</span></WorkScheduleContainerColumn>
    </WorkScheduleContainerRow>
    <WorkScheduleContainerRow v-for="groupLabel in groupLabels" :key="groupLabel.id">
        <WorkScheduleContainerColumn stickyLeft><span class="groupName">{{ groupLabel.name }}</span></WorkScheduleContainerColumn>
        <WorkScheduleContainerColumn timeGrid>
            <WorkSchedulePositionsPerDay
                v-for="(day) in renderedDays"
                :key="groupLabel.id + '|' + day.formattedDateIso"
                :day="day"
                :groupLabel="groupLabel"
                :renderedDateRange="renderedDateRange"
                :groupLabels="groupLabels"
                @dragStart:workSchedulePosition="$emit('dragStart:workSchedulePosition', $event)"
                @dragEnd:workSchedulePosition="$emit('dragEnd:workSchedulePosition', $event)"
            />
        </WorkScheduleContainerColumn>
    </WorkScheduleContainerRow>
</template>

<script lang="ts">
    import {PlanbordWorkScheduleGroupLabel} from '@/types/api-object-extensions';
    import WorkSchedulePositionsPerDay from '@/components/WorkSchedule/WorkSchedulePositionsPerDay.vue';
    import WorkScheduleContainerRow from '@/components/WorkSchedule/WorkScheduleContainerRow.vue';
    import WorkScheduleContainerColumn from '@/components/WorkSchedule/WorkScheduleContainerColumn.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {RenderedDay, DateRange} from '@/types/types';

    @Component({
        components: {
            WorkSchedulePositionsPerDay,
            WorkScheduleContainerRow,
            WorkScheduleContainerColumn,
        },
        emits: [
            'dragStart:workSchedulePosition',
            'dragEnd:workSchedulePosition',
        ],
    })
    export default class WorkScheduleGroupLabels extends Vue {
        @Prop({required: true}) public groupLabels!: Record<number, PlanbordWorkScheduleGroupLabel>;
        @Prop({required: true}) public renderedDateRange!: DateRange;
        @Prop({required: true}) public renderedDays!: Record<string, RenderedDay>;
    }
</script>

<style lang="scss" scoped>
    .groupName {
        font-weight: bold;
    }

    .stickyHeaderContent {
        position: sticky;
        left: 10rem;
        z-index: 2;
        padding-left: 0.25rem;
    }
</style>
